/**
 * Email ready for /users/check-password-set:
 * - needs local@domain.tld
 * - TLD at least 2 letters (skips `a@b.c` while typing `.com`)
 */
const VALID_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;

const PASSWORD_CHECK_DEBOUNCE_PHONE_MS = 400;
/** Longer so slow typing/deletion of a TLD (e.g. .com) settles to one request. */
const PASSWORD_CHECK_DEBOUNCE_EMAIL_MS = 1500;

export function isValidLoginEmail(email) {
  return VALID_EMAIL_REGEX.test(String(email || '').trim());
}

export function getPasswordCheckDebounceMs({ isEmail }) {
  return isEmail ? PASSWORD_CHECK_DEBOUNCE_EMAIL_MS : PASSWORD_CHECK_DEBOUNCE_PHONE_MS;
}

/**
 * Build the password-check key, or null if nothing should be checked yet.
 * Phone (10 digits) wins over email.
 */
export function getLoginPasswordCheckKey(phone, email) {
  const digits = String(phone || '').replace(/\D/g, '');
  if (digits.length === 10) return `phone:${digits}`;
  const trimmed = String(email || '').trim();
  if (isValidLoginEmail(trimmed)) return `email:${trimmed}`;
  return null;
}
